import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../../models/Action";
import { IEntitlementItem } from "../../../../models/Entitlements";
import { immutableSet } from "../../../../utils/immutable";
import { IEntitlementPropertyItem } from "../ApplicationsAbilitationsManagementStepFour/module/constants";
import {
  IApplicationPaginatedItem,
  IApplicationPropertyItem,
} from "../ApplicationsAbilitationsManagementStepOne/module/constants";
import {
  IEntitlementPaginatedItem,
  IEntitlementPaginatedRawData,
} from "../ApplicationsAbilitationsManagementStepThree/module/constants";
import { actionTypes } from "./actions";
import {
  applicationsAbilitationsManagementValueBooleanType,
  STATE_IDENTIFIER,
} from "./constants";
import emptyState from "./emptyState";
import { IDENTITY_SYSTEM } from "../../../../module/constants";

const {
  SELECTED_APPLICATION,
  APPLICATION_LIST_RAW,
  SELECTED_ENTITLEMENT,
  ENTITLEMENT_LIST_RAW,
  CUSTOM_PROPERTIES,
  SYSTEM_PROPERTIES,
  CALL_STATE,
  LOADER_IDENTIFIER,
  BAO,
  LIST_IDENTIFIER,

  STE_ONE,
  APPLICATIONS_LIST,

  STEP_TWO,
  STEP_THREE,
  ENTITLEMENTS_LIST,

  STEP_FOUR,
  STEP_FIVE,
  GLOBAL_ENTITLEMENTS_LIST,
  CHAIN_ENTITLEMENTS_LIST,
  CHAIN_ENTITLEMENTS_LIST_ADDED,
  CHAIN_ENTITLEMENTS_LIST_DELETED,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.FETCH_APPLICATIONS_MGMT_REQUEST]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),

  [actionTypes.FETCH_APPLICATIONS_MGMT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { applications, ...paginationData } = action.payload;
    const visibleApplicationDataRaw = applications && applications;
    const tempList: IApplicationPaginatedItem[] = applications
      ? applications.map((application: any) => {
          const tempApplicationItem: IApplicationPaginatedItem = {
            identityApplicationId: application.identityApplicationId,
            name: application.name,
            description: application.description,
            identitySystemId:
              IDENTITY_SYSTEM[
                application.identitySystemId as keyof typeof IDENTITY_SYSTEM
              ],
          };
          return tempApplicationItem;
        })
      : [];
    const modifiedPayload = {
      ...paginationData,
      applications: tempList,
    };
    return compose(
      immutableSet([APPLICATION_LIST_RAW], visibleApplicationDataRaw),
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([STE_ONE, APPLICATIONS_LIST], modifiedPayload)
    )(state);
  },

  [actionTypes.FETCH_APPLICATIONS_MGMT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([LOADER_IDENTIFIER], false, state),

  [actionTypes.APPLICATION_MGMT_SELECTION]: (state: any, action: any) => {
    const selectedApplication = action.payload;
    return immutableSet([SELECTED_APPLICATION], selectedApplication, state);
  },

  [actionTypes.FETCH_APPLICATION_PROPERTIES]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),

  [actionTypes.FETCH_APPLICATION_PROPERTIES_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const response: IApplicationPropertyItem = { ...action.payload };
    const { enrichments, ...rest } = response;

    const customPropertiesList = enrichments?.map((prop) => {
      return {
        uniqueId: prop.idProperty,
        description: prop.description,
        value: prop.value,
      };
    });

    const systemPropertiesList: any[] = [];
    Object.keys(rest).forEach((key) => {
      let tempValue = rest[key];
      if (rest[key] === true)
        tempValue = applicationsAbilitationsManagementValueBooleanType.YES;
      if (rest[key] === false)
        tempValue = applicationsAbilitationsManagementValueBooleanType.NO;
      const obj: any = {
        uniqueId: `${key}`,
        description: key,
        valueSystemPropertyAdminApplicationsAbilitationsMgmt: `${tempValue}`,
      };
      if (
        key === "name" ||
        key === "identitySystemId" ||
        key === "identityApplicationId"
      ) {
        if (key === "identitySystemId") {
          const tempValue =
            IDENTITY_SYSTEM[
              obj.valueSystemPropertyAdminApplicationsAbilitationsMgmt as keyof typeof IDENTITY_SYSTEM
            ];
          obj.valueSystemPropertyAdminApplicationsAbilitationsMgmt = tempValue;
        }
        obj.editable = false;
      } else {
        obj.editable = undefined;
      }
      systemPropertiesList.push(obj);
    });
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([STEP_TWO, CUSTOM_PROPERTIES], customPropertiesList),
      immutableSet([STEP_TWO, SYSTEM_PROPERTIES], systemPropertiesList)
    )(state);
  },

  [actionTypes.FETCH_APPLICATION_PROPERTIES_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([STEP_TWO, CUSTOM_PROPERTIES], [])
    )(state);
  },

  [actionTypes.GET_BAO]: (state: any, action: any) =>
    immutableSet([BAO, LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_BAO_SUCCESS]: (state: any, action: any) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((user: any) => {
        let toAdd: any = {
          code: user.code,
          name: user.name,
          surname: user.surname,
          organizational_unit_code: user.organizational_unit_code,
        };
        mappedResponse.push(toAdd);
      });
    return compose(
      immutableSet([BAO, LIST_IDENTIFIER], mappedResponse),
      immutableSet([BAO, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_BAO_FAILURE]: (state: any, action: any) =>
    immutableSet([BAO, LOADER_IDENTIFIER], false, state),

  [actionTypes.UPDATE_APPLICATION_PROPERTIES]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),

  [actionTypes.UPDATE_APPLICATION_PROPERTIES_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(immutableSet([CALL_STATE], IResponseState.SUCCESS))(state);
  },

  [actionTypes.UPDATE_APPLICATION_PROPERTIES_FAILURE]: (
    state: any,
    action: any
  ) => {
    return immutableSet([CALL_STATE], IResponseState.ERROR, state);
  },

  [actionTypes.FETCH_ENTITLEMENTS_MGMT_REQUEST]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),

  [actionTypes.FETCH_ENTITLEMENTS_MGMT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { entitlements, ...paginationData } = action.payload;
    const visibleEntitlementsDataRaw: IEntitlementPaginatedRawData[] =
      entitlements && entitlements;
    const tempList: IEntitlementPaginatedItem[] = entitlements
      ? entitlements.map((entitlement: any) => {
          const tempApplicationItem: IEntitlementPaginatedItem = {
            identity_system_id: entitlement.identity_system_id,
            entitlement_id: entitlement.entitlement_id,
            application_name: entitlement.application_name,
            application_description: entitlement.application_description,
            entitlement_name: entitlement.entitlement_name,
            entitlement_description: entitlement.entitlement_description,
            show_on_frontend_console_admin_applications_abilitations_mgmt:
              entitlement.showOnFrontend === true
                ? applicationsAbilitationsManagementValueBooleanType.YES
                : // ? "true"
                entitlement.showOnFrontend === false
                ? applicationsAbilitationsManagementValueBooleanType.NO
                : // ? "false"
                  "null",
            baoInfo: entitlement.baoFullName ? entitlement.baoFullName : "",
            identitySystemId:
              IDENTITY_SYSTEM[
                entitlement.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
          };
          return tempApplicationItem;
        })
      : [];
    const modifiedPayload = {
      ...paginationData,
      entitlements: tempList,
    };
    return compose(
      immutableSet([ENTITLEMENT_LIST_RAW], visibleEntitlementsDataRaw),
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([STEP_THREE, ENTITLEMENTS_LIST], modifiedPayload)
    )(state);
  },

  [actionTypes.FETCH_ENTITLEMENTS_MGMT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([LOADER_IDENTIFIER], false, state),

  [actionTypes.ENTITLEMENT_MGMT_SELECTION]: (state: any, action: any) => {
    const selectedEntitlements = action.payload;
    return compose(immutableSet([SELECTED_ENTITLEMENT], selectedEntitlements))(
      state
    );
  },

  [actionTypes.FETCH_ENTITLEMENT_PROPERTIES]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),

  [actionTypes.FETCH_ENTITLEMENT_PROPERTIES_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const response: IEntitlementPropertyItem = { ...action.payload };
    const { enrichments, ...rest } = response;

    const customPropertiesList = enrichments?.map((prop) => {
      return {
        uniqueId: prop.idProperty,
        description: prop.description,
        value: prop.value,
      };
    });

    const systemPropertiesList: any[] = [];
    Object.keys(rest).forEach((key) => {
      let tempValue = rest[key];
      if (rest[key] === true)
        tempValue = applicationsAbilitationsManagementValueBooleanType.YES;
      if (rest[key] === false)
        tempValue = applicationsAbilitationsManagementValueBooleanType.NO;
      if (key === "baoCode") {
        let bao = [...state.bao.list];
        bao.forEach((el: any) => {
          if (el.code === rest[key]) {
            tempValue = `${el.name} ${el.surname} [${el.code}]`;
          }
        });
      }
      const obj: any = {
        uniqueId: `${key}`,
        description: key,
        valueSystemPropertyAdminApplicationsAbilitationsMgmt: `${tempValue}`,
      };
      if (
        key === "entitlementName" ||
        key === "entitlementId" ||
        key === "identitySystemId" ||
        key === "applicationName"
      ) {
        if (key === "identitySystemId") {
          const tempValue =
            IDENTITY_SYSTEM[
              obj.valueSystemPropertyAdminApplicationsAbilitationsMgmt as keyof typeof IDENTITY_SYSTEM
            ];
          obj.valueSystemPropertyAdminApplicationsAbilitationsMgmt = tempValue;
        }
        obj.editable = false;
      } else {
        obj.editable = undefined;
      }
      systemPropertiesList.push(obj);
    });
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([STEP_FOUR, CUSTOM_PROPERTIES], customPropertiesList),
      immutableSet([STEP_FOUR, SYSTEM_PROPERTIES], systemPropertiesList)
    )(state);
  },

  [actionTypes.FETCH_ENTITLEMENT_PROPERTIES_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([STEP_FOUR, SYSTEM_PROPERTIES], []),
      immutableSet([STEP_FOUR, CUSTOM_PROPERTIES], [])
    )(state);
  },

  [actionTypes.UPDATE_ENTITLEMENT_PROPERTIES]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),

  [actionTypes.UPDATE_ENTITLEMENT_PROPERTIES_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(immutableSet([CALL_STATE], IResponseState.SUCCESS))(state);
  },

  [actionTypes.UPDATE_ENTITLEMENT_PROPERTIES_FAILURE]: (
    state: any,
    action: any
  ) => {
    return immutableSet([CALL_STATE], IResponseState.ERROR, state);
  },

  [actionTypes.FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([LOADER_IDENTIFIER], true, state),

  [actionTypes.FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { entitlements, ...paginationData } = action.payload;
    const visibleEntitlementsDataRaw: IEntitlementPaginatedRawData[] =
      entitlements && entitlements;
    const tempList: IEntitlementItem[] = entitlements
      ? entitlements.map((entitlement: any) => {
          const tempApplicationItem: IEntitlementItem = {
            ...entitlement,
            identitySystemId:
              IDENTITY_SYSTEM[
                entitlement.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
          };
          return tempApplicationItem;
        })
      : [];
    const modifiedPayload = {
      ...paginationData,
      entitlements: tempList,
    };
    return compose(
      immutableSet([ENTITLEMENT_LIST_RAW], visibleEntitlementsDataRaw),
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([STEP_FIVE, GLOBAL_ENTITLEMENTS_LIST], modifiedPayload)
    )(state);
  },

  [actionTypes.FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([LOADER_IDENTIFIER], false, state),

  [actionTypes.FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([STEP_FIVE, LOADER_IDENTIFIER], true, state),

  [actionTypes.FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([STEP_FIVE, LOADER_IDENTIFIER], false),
      immutableSet([STEP_FIVE, CHAIN_ENTITLEMENTS_LIST], action.payload)
    )(state);
  },

  [actionTypes.FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([STEP_FIVE, LOADER_IDENTIFIER], false),
      immutableSet([STEP_FIVE, CHAIN_ENTITLEMENTS_LIST], [])
    )(state);
  },

  [actionTypes.UPDATE_CHAIN_ENTITLEMENT_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),

  [actionTypes.UPDATE_CHAIN_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),

  [actionTypes.UPDATE_CHAIN_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.SET_CHAIN_ENTITLEMENT_TO_LIST]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_FIVE, CHAIN_ENTITLEMENTS_LIST], action.payload)
    )(state);
  },

  [actionTypes.ADD_CHAIN_ENTITLEMENT_TO_LIST]: (state: any, action: any) => {
    return compose(
      immutableSet(
        [STEP_FIVE, CHAIN_ENTITLEMENTS_LIST_ADDED],
        [...action.payload]
      )
    )(state);
  },

  [actionTypes.REMOVE_CHAIN_ENTITLEMENT_FROM_LIST]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet(
        [STEP_FIVE, CHAIN_ENTITLEMENTS_LIST_DELETED],
        [...action.payload]
      )
    )(state);
  },

  [actionTypes.RESET_CHAIN_ENTITLEMENT_LIST]: (state: any) => {
    return compose(
      immutableSet([STEP_FIVE, GLOBAL_ENTITLEMENTS_LIST], {}),
      immutableSet([STEP_FIVE, CHAIN_ENTITLEMENTS_LIST], []),
      immutableSet([STEP_FIVE, CHAIN_ENTITLEMENTS_LIST_ADDED], []),
      immutableSet([STEP_FIVE, CHAIN_ENTITLEMENTS_LIST_DELETED], [])
    )(state);
  },
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
